import axios from 'axios';

const get = async () =>{
    const response = await axios.get('/reservations/vue/resources/skier_types');
    return response.data.data;
}

export default get;

